<div class="content">
    <list-view *ngIf="listeTaux" [liste]="listeTaux"></list-view>
</div>